module.exports = __webpack_public_path__ + "pinglun.994fab24.png";